import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {RelationType} from "../../../commons/types/relation.type";

export class RelationTypeMultiSelectListComponent implements IController {
  relationTypes: RelationType[];
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(RelationType));
    }
  }

  $onChanges(changes) {
    if (changes.relationTypes) {
      this.selectedKeys = [];
      _.forEach(this.relationTypes, (relationType) => {
        this.selectedKeys[relationType] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      relationTypes: isSelected ? _.concat(this.relationTypes || [], [option]) :
        _.filter(this.relationTypes, (relationType) => {
          return relationType !== option;
        })
    });
  }

  onReset() {
    this.onChange({relationTypes: []});
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('relationTypeMultiSelectList', {
    bindings: {
      relationTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./relation-type-multi-select-list.html').default,
    controller: RelationTypeMultiSelectListComponent
  });
